<nz-form-control>
  <ng-content></ng-content>
</nz-form-control>
<div *ngIf="errorMessage as config" class="error-message" @fadeAnimation>
  <img src="/assets/icons/page-table/warning.svg" alt="warning" />
  {{ config.options.length }} {{ config.key | translate }}
</div>
